import {
  cn
} from "./chunk-J3MZFSES.js";

// src/components/button.tsx
import { Slot as SlotPrimitive } from "radix-ui";
import { cva } from "class-variance-authority";
import { jsx } from "react/jsx-runtime";
var buttonVariants = cva(
  "inline-flex items-center justify-center gap-1.5 min-w-fit rounded-xs text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-3.5 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground shadow-xs hover:bg-primary-700",
        destructive: "bg-danger-600 text-white shadow-xs hover:bg-danger-700 focus-visible:ring-danger-600/20 dark:focus-visible:ring-danger-600/40",
        outline: "border-input border bg-background shadow-xs hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50",
        secondary: "bg-secondary text-secondary-foreground shadow-xs hover:bg-secondary/80",
        ghost: "text-foreground-700 hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50",
        link: "text-primary underline-offset-4 hover:underline",
        black: "bg-foreground text-white border-none hover:bg-foreground/90"
      },
      size: {
        default: "h-8 px-2.5 py-1.5",
        sm: "h-7 px-2 py-1.5 text-xs leading-4",
        lg: "h-9 px-8 py-2",
        xs: "h-6 gap-1 px-1.5 py-1 text-xs leading-4",
        icon: "size-8 p-2",
        "icon-sm": "size-7 p-1.5",
        "icon-xs": "size-6 p-1"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);
function Button({
  className,
  variant,
  size,
  asChild = false,
  ...props
}) {
  const Comp = asChild ? SlotPrimitive.Slot : "button";
  return /* @__PURE__ */ jsx(
    Comp,
    {
      "data-slot": "button",
      className: cn(buttonVariants({ variant, size, className })),
      ...props
    }
  );
}

export {
  buttonVariants,
  Button
};
//# sourceMappingURL=chunk-R4KT2AQC.js.map